<template>
  <div class="mb-5">
    <div class="box">
      <h2 class="has-text-centered is-size-4-mobile" v-bind:id="formula.title.replace(/\s+/g, '')">{{ formula.title }}</h2>
      <div class="columns">
        <div class="column is-half">
          <span v-for="(single_formula, index) in formula.formulas" :key="index" v-katex:display="single_formula.content"></span>
        </div>
        <div class="column is-half">
          <table class="table is-striped is-hoverable">
            <tbody>
              <tr class="is-size-7-mobile" v-for="(variable, index) in formula.variables" :key="index">
                <td>
                  <span v-katex="variable.short"></span>
                </td>
                <td>...</td>
                <td>
                  {{ variable.description }} <span v-if="(variable.unit.name != '') || (variable.unit.short != '')">in</span><span v-if="variable.unit.name != ''"> {{ variable.unit.name }}</span><span v-if="variable.unit.short != ''"> [<span v-katex="variable.unit.short"></span>]</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-formula',
  props: {
    formula: { type: Object, required: true }
  }
}
</script>
